import {cabinetNotificationsApi} from "./cabinetNotifications";

/** Группы событий трейдера в порядке показа. */
export const TRADER_NOTIFICATION_GROUP_KEYS = ["order_created", "success", "cancel", "dispute", "balance"] as const;

export const traderNotificationsApi = cabinetNotificationsApi("/trader/me/notifications");
